export default __webpack_public_path__ + "static/media/illustration_doc.3c525920.svg";